import { UserSelectFilterScope } from '../inputs/UserSelect'
import PersonFilter, { type PersonFilterProps } from './PersonFilter'

interface TeamMemberFilterProps
  extends Omit<PersonFilterProps, 'filterScope'> {}

const TeamMemberFilter = (props: TeamMemberFilterProps) => (
  <PersonFilter filterScope={UserSelectFilterScope.Staff} {...props} />
)

export default TeamMemberFilter
